import { render, staticRenderFns } from "./GridColumn.vue?vue&type=template&id=0956bbdb&scoped=true&"
import script from "./GridColumn.vue?vue&type=script&lang=js&"
export * from "./GridColumn.vue?vue&type=script&lang=js&"
import style0 from "./GridColumn.vue?vue&type=style&index=0&id=0956bbdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956bbdb",
  null
  
)

export default component.exports